import { PERMISSIONS } from '../../helpers/auth';

export const PAGES = (hasRole) => [
  {
    title: 'sme',
    description: 'sme_desc',
    iconName: 'eInvoiceGen',
    buttonName: 'generate',
    redirectUrl: 'sme',
    hide: !hasRole(PERMISSIONS.VIEW_CORE_INVOICE_LIST),
  },
  {
    title: 'special-billing-agreements',
    description: 'special_billing_desc',
    iconName: 'specialBilling',
    buttonName: 'generate',
    redirectUrl: 'special-billing',
    hide: !hasRole(PERMISSIONS.VIEW_AGREEMENT),
  },
  {
    title: 'technical_failure_notification',
    description: 'failure_desc',
    iconName: 'techFailNot',
    buttonName: 'generate',
    redirectUrl: 'failure-notification',
    hide: !hasRole(PERMISSIONS.VIEW_REPORTED_FAILURES),
  },
];

export const ROUTES = [
  {
    label: 'additional_functionalities',
    link: '',
  },
  // {
  //   label: 'breadcrumb_e_invoicing',
  //   link: 'e-invoicing',
  // },
];
